import React, { useState } from "react";
import { Form, Select, Input, Button } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const RenderFilterFields = ({
  filtersData,
  onFieldChange,
  handleClear,
  setFilterQueryParams,
}) => {
  const getStartOfMonth = () => {
    return moment().startOf("month").toDate();
  };
  const [dateValue, setDateValue] = useState(getStartOfMonth());

  const handleChange = (value, filterCode) => {
    if (filterCode === "empType") {
      setFilterQueryParams((prevParams) => ({
        ...prevParams,
        empType: value,
      }));
    }
    onFieldChange(filterCode, value);
  };

  const formatDate = (date) => {
    return date ? moment(date).format("YYYY-MM-DD") : null;
  };

  const handleDateChange = (date) => {
    const formattedDate = formatDate(date);
    setDateValue(date);
    handleChange(formattedDate, "incentiveMonthDate");
  };

  return (
    <>
      {filtersData.map((filter) => {
        switch (filter.filter_type) {
          case "code_name_spinner":
            return (
              <Form.Item
                key={filter.filter_code}
                label={filter.filter_title}
                name={filter.filter_code}
              >
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  mode={filter.is_single_select ? undefined : "multiple"}
                  options={filter.filter_values.map((val) => ({
                    label: val.value,
                    value: val.code,
                    key: `${val.code}`,
                  }))}
                  placeholder={`Select ${filter.filter_title}`}
                  defaultValue={filter.default_filter_value}
                  onChange={(value) => handleChange(value, filter.filter_code)}
                />
              </Form.Item>
            );

          case "text":
            return (
              <Form.Item
                key={filter.filter_code}
                name={filter.filter_code}
                label={filter.filter_title}
              >
                <Input
                  placeholder={`Enter ${filter.filter_title}`}
                  onChange={(e) =>
                    handleChange(e.target.value, filter.filter_code)
                  }
                />
              </Form.Item>
            );

          case "date":
            return (
              <Form.Item
                key={filter.filter_code}
                name={filter.filter_code}
                label={filter.filter_title}
                initialValue={getStartOfMonth()}
                rules={[
                  {
                    required: true,
                    message: `Please select ${filter.filter_title}`,
                  },
                ]}
              >
                <DatePicker
                  selected={dateValue}
                  onChange={handleDateChange}
                  className="px-4 py-2 react-calender-input"
                  calendarIconClassname="mt-1"
                  dateFormat="MM/yyyy"
                  showIcon
                  showMonthYearPicker
                  placeholderText="Select Month"
                />
              </Form.Item>
            );

          default:
            return null;
        }
      })}
      <div className="d-flex justify-content-between">
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
        <Button onClick={handleClear}>Clear</Button>
      </div>
    </>
  );
};

export default RenderFilterFields;
